import React from 'react';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { MessageSquare, Clock, Check } from 'lucide-react';

export default function ThemePreviewWindow({ themeId, mode }) {
  return (
    <Card className="p-6 space-y-4 h-full">
      <div className="text-sm font-medium mb-4">Live Preview</div>
      
      {/* Header Preview */}
      <div className="flex items-center justify-between pb-3 border-b border-border">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center">
            <span className="text-xs text-primary-foreground font-semibold">FP</span>
          </div>
          <span className="font-semibold text-sm">Focus Pane</span>
        </div>
        <Badge variant="secondary" className="text-xs">Preview</Badge>
      </div>

      {/* Card Preview */}
      <Card className="p-4 space-y-3">
        <div className="flex items-center gap-2">
          <MessageSquare className="h-4 w-4 text-muted-foreground" />
          <span className="font-medium text-sm">Sample Update</span>
        </div>
        <p className="text-sm text-muted-foreground">
          This is how your content will look with this theme applied. 
        </p>
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <Clock className="h-3 w-3" />
          <span>2 hours ago</span>
        </div>
      </Card>

      {/* Buttons Preview */}
      <div className="space-y-2">
        <div className="flex gap-2">
          <Button size="sm" className="flex-1">
            <Check className="h-3 w-3 mr-1" />
            Primary
          </Button>
          <Button size="sm" variant="secondary" className="flex-1">
            Secondary
          </Button>
        </div>
        <div className="flex gap-2">
          <Button size="sm" variant="outline" className="flex-1">
            Outline
          </Button>
          <Button size="sm" variant="ghost" className="flex-1">
            Ghost
          </Button>
        </div>
      </div>

      {/* Muted Background Preview */}
      <div className="p-3 bg-muted rounded-lg">
        <p className="text-xs text-muted-foreground">
          Muted background section with sample text
        </p>
      </div>

      {/* Accent Preview */}
      <div className="p-3 bg-accent rounded-lg">
        <p className="text-xs text-accent-foreground">
          Accent background with contrasting text
        </p>
      </div>
    </Card>
  );
}
